<template>
	<p :class="[textDark ? 'muted' : 'text-color-white', 'body-sm']">
		The originating advertising material was sponsored and paid for by Fundrise. {{ capitalizedSolicitor }} is
		<span v-if="!isInvestor">not</span> a client, and the originating advertising material is a paid
		{{ paymentType }}, in which {{ solicitor }} {{ paymentText }}, and as a result of such compensation has a
		conflict of interest in making such {{ paymentType }}.
		<span v-if="isInvestor">Other than {{ solicitor }}'s status as a client of Fundrise,</span>
		{{ capitalizedSolicitor }} and Fundrise are not associated with each other and have no formal relationship
		outside of this arrangement. Nothing in the advertising material should be construed as tax advice, an offer,
		recommendation, or solicitation to buy or sell any security. All investing includes risk, including the possible
		loss of money you invest, and past performance does not guarantee future performance. Additional information
		about Fundrise is contained in its
		<BaseLink
			:link="{
				router: 'offering-circulars',
				hash: '#advisors-disclosures-2',
				target: '_blank'
			}"
			class="text-color-current-color text-decoration-underline"
			>Form ADV Part 2a</BaseLink
		>. By clicking on the button on this page, you acknowledge receipt of the foregoing disclosure and the firm
		brochure accessible via the link in the preceding sentence.
	</p>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { currency } from '@filters/shared-filters';

interface Props {
	solicitor?: string;
	payment?: string;
	isCpaPartner?: boolean;
	textDark?: boolean;
	monthlyPayment?: string | undefined;
	isInvestor?: boolean;
	customPaymentCondition?: string | undefined;
}

const props = withDefaults(defineProps<Props>(), {
	solicitor: 'the partner',
	payment: currency(50, 0),
	isCpaPartner: true,
	textDark: true,
	monthlyPayment: undefined,
	isInvestor: false,
	customPaymentCondition: undefined
});

const capitalizedSolicitor = computed((): string => props.solicitor.charAt(0).toUpperCase() + props.solicitor.slice(1));
const bothCpaAndFlatFee = computed((): boolean => !!props.monthlyPayment);

const paymentType = computed((): string => (props.isInvestor ? 'testimonial' : 'endorsement'));

const paymentText = computed((): string => {
	const baseText = props.isInvestor
		? `may receive cash and/or non-cash compensation of up to ${props.payment} in value`
		: `may receive up to ${props.payment}`;

	if (props.customPaymentCondition) {
		return `${baseText} ${props.customPaymentCondition}`;
	} else if (bothCpaAndFlatFee.value) {
		return `${baseText} per sign-up and up to ${props.monthlyPayment} per month`;
	} else if (props.isCpaPartner) {
		return `${baseText} per sign-up`;
	} else {
		return `${baseText} per month`;
	}
});
</script>
